import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, X } from "lucide-react";

const QUOTES = [
  ["The secret of getting ahead is getting started.", "Mark Twain"],
  ["Quality means doing it right when no one is looking.", "Henry Ford"],
  ["Great things are done by a series of small things brought together.", "Vincent van Gogh"],
  ["Success is the sum of small efforts repeated day in and day out.", "Robert Collier"],
  ["Well done is better than well said.", "Benjamin Franklin"],
  ["Don't watch the clock; do what it does. Keep going.", "Sam Levenson"],
  ["Discipline is the bridge between goals and accomplishment.", "Jim Rohn"],
  ["Your work is going to fill a large part of your life — make it count.", "Steve Jobs"],
  ["It always seems impossible until it's done.", "Nelson Mandela"],
  ["Small daily improvements are the key to staggering long-term results.", "Anonymous"],
  ["Focus on being productive instead of busy.", "Tim Ferriss"],
  ["A goal without a plan is just a wish.", "Antoine de Saint-Exupéry"],
  ["The future depends on what you do today.", "Mahatma Gandhi"],
  ["Consistency is what transforms average into excellence.", "Anonymous"],
];

export default function QuoteToast() {
  const { user } = useAuth();
  const [quote, setQuote] = useState(null);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!user) return;
    const today = new Date().toISOString().slice(0, 10);
    const key = `abs_quote_${user.id}`;
    if (localStorage.getItem(key) === today) return;
    localStorage.setItem(key, today);
    const idx = Math.abs(today.split("-").join("") * 1 + (user.id || "").length) % QUOTES.length;
    setQuote(QUOTES[idx]);
    const t1 = setTimeout(() => setLeaving(true), 11500);
    const t2 = setTimeout(() => setQuote(null), 12500);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [user]);

  if (!quote) return null;
  return (
    <div
      className={`fixed bottom-5 right-5 z-[100] max-w-sm rounded-2xl border border-border bg-card shadow-2xl p-5 transition-all duration-700 ${leaving ? "opacity-0 translate-y-3" : "opacity-100 translate-y-0"}`}
      data-testid="daily-quote"
    >
      <button onClick={() => setQuote(null)} className="absolute top-2.5 right-2.5 text-muted-foreground hover:text-foreground" data-testid="quote-close"><X className="h-4 w-4" /></button>
      <div className="flex items-center gap-2 text-primary mb-2"><Sparkles className="h-4 w-4" /><span className="text-xs font-semibold uppercase tracking-wider">Today's spark</span></div>
      <p className="text-sm leading-relaxed text-foreground">"{quote[0]}"</p>
      <p className="text-xs text-muted-foreground mt-2">— {quote[1]}</p>
    </div>
  );
}
